import { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
import Axios from 'axios';

export default function VideoPlayer ({ src, poster, playtime = '00:00' }) {
  const videoRef = useRef(null);
  const [playcheck, setPlayCheck] = useState(null);
  const [videoPlayInfo, setVideoPlayInfo] = useState({
    mediaUrl: src,
    expireDate: null
  });

  useEffect(() => {
    // play api로 영상 url을 내려받아야 하는 경우, 10분 만료시간처리
    if (/https?:\/\/apis.sbs.co.kr/.test(src)) {
      if (!videoPlayInfo.expireDate || videoPlayInfo.expireDate < new Date()) {
        // //console.log('mediaUrl updat start');
        // //console.log('mediaUrl updat start : ' + src);
        Axios.get(src).then((response) => {
          setVideoPlayInfo({
            mediaUrl: response.data,
            expireDate: new Date(Number.parseInt((Date.now() + 10 * 60000) / 100000) * 100000)
          });
          // //console.log('mediaUrl updat end');
        });
      }
    }
  }, [playcheck]);

  useEffect(() => {
    if (!videoRef.current) return;

    // //console.log('videoRef load');
    if (videoRef.current && videoPlayInfo.mediaUrl) {
      videoRef.current.controls = false;

      if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
        videoRef.current.src = videoPlayInfo.mediaUrl;
      } else if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(videoPlayInfo.mediaUrl);
        hls.attachMedia(videoRef.current);
      } else {
        setPlayCheck(null);
        return;
      }
      videoRef.current.addEventListener('ended', function () {
        setPlayCheck(true);
      });
      // //console.log('video tag loaded finished');
    }

    if (playcheck !== null) {
      if (playcheck) {
        videoRef.current.currentTime = 0;
        // videoRef.current.pause();
      } else {
        const playResult = videoRef.current.play();
        if (playResult) {
          playResult.then(_ => {
            // //console.log('Autoplay started!');
            // setPlayCheck(false);
          }).catch(error => {
            setPlayCheck(true);
            console.error(error);
          });
        }
      }
    }
  }, [videoRef.current, playcheck]);

  function onMouseOverPlayerPlaying (e) {
    setPlayCheck(false);
  }

  function onMouseOutPlayerPause (e) {
    setPlayCheck(true);
  }

  return (
    <div className='hmb_video_inner' onMouseOut={onMouseOutPlayerPause} onMouseOver={onMouseOverPlayerPlaying}>
      {(playcheck === null || playcheck)
        ? <>
          <div className='hmb_image_inner'>
            <img src={poster} className='hmb_image' alt='' />
          </div>
          <div className='hmb_label_w'>
            <span className='hmb_label_time' title='클립 재생 시간'>{playtime}</span>
          </div>
        </>
        : <video
            id='video'
            muted
            controls={false}
            ref={videoRef}
            style={{ maxWidth: '100%' }}
            poster={poster}
            preload='none'
          />}

    </div>
  );
}
